import { CustomerFilterModel } from "../../clients/KompasApi";
import { Box, Text } from "@chakra-ui/react";
import { atom, useAtom } from "jotai";
import { Dropdown } from "../Dropdown";

export const customerIdAtom = atom<number | undefined>(undefined);

interface Props {
  options: CustomerFilterModel[];
}

export function CustomerFilter({ options }: Props) {
  const [customerId, setCustomerId] = useAtom(customerIdAtom);

  if (!options.length) return null;

  return (
    <Box>
      <Text fontSize="sm" fontWeight="500">
        Opdrachtgever
      </Text>
      <Dropdown
        allowSearch
        items={options}
        onChange={([item]) => {
          setCustomerId(item?.id);
        }}
        popoverWidth="lg"
        resetText="Reset filters"
        searchPlaceholder="Zoek opdrachtgever"
        showResultCount
        title="Opdrachtgever"
        value={options.filter((o) => o.id === customerId)}
        valueDisplay={customerId ? <Text>{options.find((o) => o.id === customerId)?.name}</Text> : <Text color="gray.500" fontStyle="italic">Selecteer opdrachtgever</Text>}
      />
    </Box>
  );
}
